<script>
import { mapState } from 'vuex'
import DatePicker from './DatePicker'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: DatePicker, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            note: (state) =>
                _.startCase(_.toLower(state.registration.idDocumentExpiryNote)),
        }),
    }, // End of Component > computed
}
</script>
